import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import WarningModal from 'shared-components/WarningModal/WarningModal';

import { hideSponsoredWarning as hideSponsoredWarningAction } from 'services/actions/productsActions';
import { requestRemoveFromCart as requestRemoveFromCartAction } from 'services/actions/cartActions';

import { selectIsVariantToRemoveSponsored } from 'selectors/productsSelectors';

export const CONTENT = {
  sponsored: {
    title: 'Are you sure you want to remove this Free Gift?',
    message:
      'Quantities are limited and you might not have an opportunity to add this again!',
  },
  nonSponsored: {
    title: 'Are you sure you want to remove this product?',
    message: "You'll lose your Free Gift :(",
  },
};

const SponsoredWarningPopup = ({
  variantToRemove,
  shouldDisplaySponsoredPopupWarning,
  isVariantToRemoveSponsored,
  hideSponsoredWarning,
  requestRemoveFromCart,
}) => {
  const copy =
    CONTENT[isVariantToRemoveSponsored ? 'sponsored' : 'nonSponsored'];
  const { title, message } = copy;
  const handleConfirmation = () => requestRemoveFromCart(variantToRemove);

  return (
    <WarningModal
      isOpen={shouldDisplaySponsoredPopupWarning}
      title={title}
      message={message}
      cancelText="Cancel"
      confirmText="Yes, I want to remove this product"
      onClickCancel={hideSponsoredWarning}
      onClickConfirm={handleConfirmation}
    />
  );
};

SponsoredWarningPopup.propTypes = {
  variantToRemove: PropTypes.string.isRequired,
  shouldDisplaySponsoredPopupWarning: PropTypes.bool.isRequired,
  isVariantToRemoveSponsored: PropTypes.bool.isRequired,
  hideSponsoredWarning: PropTypes.func.isRequired,
  requestRemoveFromCart: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    variantToRemove: state.productsState.variantToRemove,
    shouldDisplaySponsoredPopupWarning:
      state.productsState.shouldDisplaySponsoredPopupWarning,
    isVariantToRemoveSponsored: selectIsVariantToRemoveSponsored(state),
  };
};

export default connect(mapStateToProps, {
  hideSponsoredWarning: hideSponsoredWarningAction,
  requestRemoveFromCart: requestRemoveFromCartAction,
})(SponsoredWarningPopup);
